function Url(t) {
    void 0 === t && (t = window.location.pathname + window.location.search + window.location.hash), this.url = decodeURIComponent(t), this.params
}

Url.prototype = {
    setParam: function (t, r) {
        const e = this, n = new RegExp("([?&]" + e.escapeBrackets(t) + "=)[^&]+", "");
        return 0 === r.length || (-1 === e.url.indexOf("?") ? e.add("?", t, r) : n.test(e.url) ? e.change(n, r) : e.add("&", t, r)), e.url
    }, setParams: function (t) {
        const s = this, o = function (t, r, e) {
            let n, i;
            for (const a in t) t.hasOwnProperty(a) && (n = e ? r ? r + a : a : r ? r + "[" + a + "]" : a, "object" == typeof (i = t[a]) ? o(i, n) : s.setParam(n, i))
        };
        o(t, "", !0)
    }, getParams: function () {
        let e = {};
        let r = /[?&]([^=#]+)=([^&#]*)/g;
        let t;
        for (; t = r.exec(this.url);) e[t[1]] = t[2];
        return e
    }, removeParam: function (t) {
        let r = this.url.split("?")[0], e = [], n = -1 !== this.url.indexOf("?") ? this.url.split("?")[1] : "";
        if ("" !== n) {
            for (let i = (e = n.split("&")).length - 1; 0 <= i; i -= 1) e[i].split("=")[0] === t && e.splice(i, 1);
            const a = e.join("&");
            this.url = r + (a.length ? "?" : "") + a
        }
        return this.url
    }, addHash: function (t) {
        const r = this.url.split("#");
        r[1] ? this.url = this.url.replace(r[1], t) : this.url = this.url + "#" + t
    }, getHash: function () {
        const t = this.url.split("#");
        return !!t[1] && t[1]
    }, getParam: function (t, r) {
        return this.params || (this.params = this.getParams()), void 0 !== this.params[t] ? this.params[t] : r
    }, getUrl: function () {
        return decodeURI(this.url)
    }, add: function (t, r, e) {
        this.url += t + r + "=" + encodeURIComponent(e)
    }, change: function (t, r) {
        this.url = this.url.replace(t, "$1" + encodeURIComponent(r))
    }, escapeBrackets: function (t) {
        return t.replace(/[[]/g, "\\[").replace(/]/g, "\\]")
    }, update: function () {
        history.pushState({}, null, this.getUrl())
    }
};

export default Url